var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9775 8.0685L22.62 2.6355C22.4535 1.968 21.8535 1.5 21.165 1.5H2.8365C2.148 1.5 1.548 1.968 1.38 2.6355L0.0225 8.0685C0.0075 8.127 0 8.1885 0 8.25C0 10.317 1.5975 12 3.5625 12C4.704 12 5.7225 11.4315 6.375 10.5495C7.0275 11.4315 8.046 12 9.1875 12C10.329 12 11.3475 11.4315 12 10.5495C12.6525 11.4315 13.6695 12 14.8125 12C15.9555 12 16.9725 11.4315 17.625 10.5495C18.2775 11.4315 19.2945 12 20.4375 12C22.4025 12 24 10.317 24 8.25C24 8.1885 23.9925 8.127 23.9775 8.0685Z",
    fill: "#ABB5BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 13.4999C19.416 13.4999 18.4455 13.1879 17.625 12.6179C15.984 13.7594 13.641 13.7594 12 12.6179C10.359 13.7594 8.016 13.7594 6.375 12.6179C5.5545 13.1879 4.584 13.4999 3.5625 13.4999C2.826 13.4999 2.1315 13.3274 1.5 13.0334V20.9999C1.5 21.8279 2.172 22.4999 3 22.4999H9V16.4999H15V22.4999H21C21.828 22.4999 22.5 21.8279 22.5 20.9999V13.0334C21.8685 13.3274 21.174 13.4999 20.4375 13.4999Z",
    fill: "#ABB5BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopNormal);
export default __webpack_public_path__ + "static/media/shop_normal.89fd28730cf0b22c11066df9afc87b3e.svg";
export { ForwardRef as ReactComponent };